import { render, staticRenderFns } from "./BaseMenu.vue?vue&type=template&id=da3b398a"
import script from "./BaseMenu.vue?vue&type=script&lang=ts"
export * from "./BaseMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports